export default __webpack_public_path__ + "static/media/sser.ea3ec184.svg";